import { cls } from '../lib/util';
export function Avatar({ u, size = 'md', online }: { u: { avatar?: string; frame?: string; display_name?: string }; size?: 'sm' | 'md' | 'lg'; online?: boolean }) {
  return (
    <span className={cls('avatar', size, u.frame === 'gold' && 'gold')} aria-label={u.display_name} role="img">
      {u.avatar || '🙂'}
      {online != null && <i className={cls('dot', online && 'on')} aria-label={online ? 'online' : 'offline'} />}
    </span>
  );
}
